<script>
import {
    explorerState
} from '@app/store/explorerStore.svelte.js';
import {
    establishHistoryBaseline
} from "@app/store/historyStore.svelte.js";
import {
    authState
} from '@app/store/authStore.svelte.js';
import {
    speakerState
} from '@app/store/speakerStore.svelte.js';
import {
    issueState
} from '@app/store/issueStore.svelte.js';
import {
    markerState
} from '@app/store/markerStore.svelte.js';
import {
    metadataState
} from '@app/store/metadataStore.svelte.js';
import {
    styleState
} from '@app/store/styleStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import { ccprjFunc } from '@app/lib/ccprj.js';
import { toast } from '@zerodevx/svelte-toast';
import Swal from "sweetalert2";
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import * as m from '@app/paraglide/messages.js';
import MenuItem from "../../menu/MenuItem.svelte";

/* Firebase */
import { auth } from '@app/configs/firebase.js';
import db from '@app/configs/firestore.js';
import storage from '@app/configs/storage.js';
import { collection, doc, getDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { ref, uploadString } from 'firebase/storage';
let userId = auth.currentUser.uid,
    userEmail = auth.currentUser.email,
    teamId = authState.team ? authState.team.id : null,
    homeRef = collection(db, "users", userId, "storage"),
    teamRef = teamId ? collection(db, "teams", teamId, "storage") : null,
    storageRef = ref(storage),
    teamDriveUploadBasePath = "teams/" + teamId + "/storage/",
    myDriveUploadBasePath = "users/" + userId + "/projects/";

async function saveProject() {
    // Show immediate feedback that save is in progress
    toast.push(m.saving_project(), {classes: ['toast-info']});
    
    if (projectState.rootDir === 'team' && !teamId) {
        teamId = authState.team ? authState.team.id : null;        
        teamRef = teamId ? collection(db, "teams", teamId, "storage") : null;
        teamDriveUploadBasePath = "teams/" + teamId + "/storage/";
    }

    // Check if the project record exists and if it's locked
    try {
        const dbRef = projectState.rootDir === 'team' ? teamRef : homeRef;
        const docRef = await getDoc(doc(dbRef, projectState.id));
        
        if (docRef.exists()) {
            const projectRecord = docRef.data();
            
            // If project is locked by someone else, show warning and suggest saving as new copy
            if (projectRecord.locked && projectRecord.lockedBy !== userEmail) {
                const result = await Swal.fire({
                    ...SWAL_BASE,
                    customClass: SWAL_CLASSES.confirmCancel,
                    title: m.project_is_locked(),
                    text: m.project_locked_by({ user: projectRecord.lockedBy }),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: m.save_as_new_copy(),
                    cancelButtonText: m.cancel(),
                });
                
                if (result.isConfirmed) {
                    saveProjectAs();
                }

                return;
            }
        }
        
        // Continue with normal save process if not locked or locked by current user
        let projectJson = ccprjFunc.createCcprj({
            project : JSON.parse(JSON.stringify(projectState)),
            metadata : JSON.parse(JSON.stringify(metadataState)),
            speakers : JSON.parse(JSON.stringify(speakerState)),
            issues : JSON.parse(JSON.stringify(issueState.value)),
            markers : JSON.parse(JSON.stringify(markerState)),
            eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
            style : JSON.parse(JSON.stringify(styleState))
        });

        let projectFilePath = projectState.rootDir === 'team' ? teamDriveUploadBasePath+ projectState.id : myDriveUploadBasePath + projectState.id;

        await uploadString(ref(storageRef, projectFilePath), JSON.stringify(projectJson));
        
        let projectInfo = {
            id: projectState.id,
            name: projectState.name,
            type: projectState.type === "team" ? "team project" : "project",
            updatedOn: Timestamp.fromDate(new Date()),
            shared : projectState.rootDir === 'team' ? true : false,
            locationId: projectState.folderId
        }

        await updateDoc(doc(projectState.rootDir === 'team' ? teamRef : homeRef, projectInfo.id), projectInfo);
        toast.push(m.project_saved_success(), {classes: ['toast-success']});
        establishHistoryBaseline({ name: "save project" });
    } catch (error) {
        console.log("Error saving project: ", error);
        toast.push(error.message, {classes: ['toast-danger']});
    }
}

async function saveProjectAs() {
    explorerState.context = "save";
    showModal("storageExplorer");
}
</script>
<MenuItem
    label={m.save_project()}
    icon="bi-floppy"
    id="onlineSaveMenuItem"
    shortcut="Save Project"
    onSelect={() =>
        projectState.folderId || projectState.folderId === null
            ? saveProject()
            : saveProjectAs()} />
<MenuItem
    label={m.save_project_as()}
    icon="bi-floppy2"
    id="onlineSaveAsMenuItem"
    onSelect={saveProjectAs} />